import React, { useState, useRef, useEffect } from "react";
import Konva from "konva";
import { MdCleaningServices } from "react-icons/md";
import { TbSlashes } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { Tooltip } from "react-tooltip";
import { saveAs } from "file-saver";
import { Globe, Locate, Navigation, Wifi } from "lucide-react";

export default function ViewAnswerSheet() {
  const navigate = useNavigate();
  const [stage, setStage] = useState(null);
  const location = useLocation();
  const {
    id,
    subjectId,
    barcode,
    barcodeId,
    allocationType,
    userType,
    facultyId,
    StaTus,
  } = location.state || {}; // Extract the exam ID subject ID  and barcod number from the location state
  const [cameraEnabled, setCameraEnabled] = useState(true);
  const stageRef = useRef(null); // stage for image konva
  const selectedElementRef = useRef(null); // selected element ref konva
  const layerRef = useRef(null); // layer for image  konva
  const transformerRef = useRef(null); // transformer for select element  konva
  const apiUrl = process.env.REACT_APP_API_URL; // Retrieve the API URL from environment variables
  const [pagecount, setPagecount] = useState(0); //total page are here to set
  const [pageValues, setPageValues] = useState([]); // image pagination
  const [currentIndex, setCurrentIndex] = useState(0); // image pagination
  const pathname = `${pageValues[currentIndex]}`; // image pagination
  const [loading, setLoading] = useState(true); // image loading  efect deta  hold state
  const [loaded, setLoaded] = useState(false); // save button  loading  efect deta  hold state
  const [image, setImage] = useState(""); // that is my img state
  const [pdfBlob, setPdfBlob] = useState(null); // State for  hold qsnpepr pdf
  const [answerKeyBlob, setAnswerKeyBlob] = useState(null); // State for  hold answer key pdf
  const [grandTotal, setGrandTotal] = useState(); // State for grand total
  const fetchTimeoutId = useRef(null);
  const [allQuestions, setAllQuestions] = useState([]); // Hold all questions across sections
  const [scores, setScores] = useState({}); // Ensure scores is initialized
  const [ClickedRowid, setClickedRowId] = useState(null);
  const [status, setStatus] = useState(0);
  const [thumbnailUrls, setThumbnailUrls] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [images, setImages] = useState([]); // New state to store images
  const [isOpen, setIsOpen] = useState(false);
  const [reasons, setReasons] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [description, setDescription] = useState("");
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isOtherQuestions, setisOtherQuestions] = useState(false);
  const currentPath = location?.pathname || "";
  const [Action, setAction] = useState(false);
  const [notAttended, setNotAttended] = useState();
  const [notsectonId, setNotsectonId] = useState();
  const [isOtherSectionQuestion, setisOtherSectionQuestion] = useState();
  const [isOrQus, setIsOrQus] = useState();
  const inputRefs = useRef({}); // Store refs for each question ID
  const [skeepPage, setSkeepPage] = useState(false);
  const [activePanel, setActivePanel] = useState(""); // "faculty" or "thumbnail"


  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const intervalRef = useRef(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const [timeData, setTimeData] = useState({
    totalTime: 0,
    formattedTime: "",
    startTime: null,
    endTime: null,
    status: "",
    startIpAddress: "",
    startLatitude: null,
    startLongitude: null,
    endIpAddress: "",
    endLatitude: null,
    endLongitude: null,
  });
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const secondsRef = useRef(seconds);

  const [facultyImages, setFacultyImages] = useState([]);
  const [facultyThumbnails, setFacultyThumbnails] = useState([]);
  const [showFacultyThumbnails, setShowFacultyThumbnails] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [facultyLocationTime, setFacultyLocationTime] = useState(false);

  const showFullImage = (index) => {
    setCurrentImageIndex(index);
    const selectedImage = facultyImages[index];
    document.getElementById("fullViewImage").src = selectedImage.image;
    const timeText = selectedImage.time
      ? new Date(selectedImage.time).toLocaleString()
      : "No time available";
    document.getElementById("fullViewCaption").textContent = `${timeText || ""}`;

    document.getElementById("thumbnailGrid").classList.add("d-none");
    document.getElementById("fullViewContainer").classList.remove("d-none");
  };

  const navigateImages = (direction) => {
    let newIndex = currentImageIndex + direction;
    if (newIndex < 0) newIndex = facultyThumbnails.length - 1;
    if (newIndex >= facultyThumbnails.length) newIndex = 0;
    showFullImage(newIndex);
  };

  // timeer
  useEffect(() => {
    let interval = null;

    if (userType !== "admin" && isActive) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isActive, userType]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    secondsRef.current = seconds;
  }, [seconds]);
  const checkRequiredPermissions = async () => {
    try {
      // Check camera permission
      if (timeData?.webcam === true) {
        const cameraPermission = await navigator.permissions.query({
          name: "camera",
        });
        if (cameraPermission.state === "denied") {
          toast.error("Camera permission is required");
          return false;
        }
      }

      if (timeData?.location === true) {
        const locationPermission = await navigator.permissions.query({
          name: "geolocation",
        });
        if (locationPermission.state === "denied") {
          toast.error("Location permission is required");
          return false;
        }
      }

      return true;
    } catch (error) {
      console.error("Permission check error:", error);
      return false;
    }
  };

  const fetchTimeData = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${apiUrl}/api/faculty/list/${id}/${subjectId}/${barcodeId}/?allocationType=${allocationType}` +
        (facultyId ? `&facultyId=${facultyId}` : ""),
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.data?.facultyLocationList) {
        const {
          totalTime,
          startTime,
          endTime,
          status,
          webcam,
          location,
          startIpAddress,
          startLatitude,
          startLongitude,
          endIpAddress,
          endLatitude,
          endLongitude,
        } = response.data.facultyLocationList;

        // Store webcam and location requirements
        setTimeData((prev) => ({
          ...prev,
          totalTime,
          formattedTime: formatTime(totalTime),
          startTime,
          endTime,
          status,
          webcam,
          location,
          startIpAddress,
          startLatitude,
          startLongitude,
          endIpAddress,
          endLatitude,
          endLongitude,
        }));

        // Check permissions
        if(userType !== "admin") {
        const hasPermissions = await checkRequiredPermissions();
        if (!hasPermissions) {
          navigate(-1);
          return;
        }
      }

        // Rest of your existing code...
        let initialSeconds = 0;
        if (typeof endTime === "number") {
          initialSeconds = endTime;
        }

        setSeconds(initialSeconds);

        // Start/stop timer based on status
        if (status === "COMPLETED") {
          setIsTimerRunning(false);
          setIsActive(false);
        } else {
          setIsTimerRunning(true);
          setIsActive(true);
          setTimeElapsed(totalTime);
        }
      }
    } catch (error) {
      console.error("Error fetching time data:", error);
      navigate(-1);
    }
  };

  const handleButtonIp = async () => {
    openNav();
    setFacultyLocationTime(true);
    await fetchTimeData();
  };

  const locationFields = [
    {
      label: "Start IP Address",
      value: timeData.startIpAddress || "Not Available",
      icon: Wifi,
      color: "blue",
    },
    {
      label: "Start Location",
      value:
        timeData.startLatitude && timeData.startLongitude
          ? `${timeData.startLatitude}, ${timeData.startLongitude}`
          : "Not Available",
      icon: Navigation,
      color: "green",
    },
    {
      label: "End IP Address",
      value: timeData.endIpAddress || "Not Available",
      icon: Wifi,
      color: "black",
    },
    {
      label: "End Location",
      value:
        timeData.endLatitude && timeData.endLongitude
          ? `${timeData.endLatitude}, ${timeData.endLongitude}`
          : "Not Available",
      icon: Locate,
      color: "red",
    },
  ];


  const bgMap = {
    blue: "bg-primary",
    green: "bg-success",
    red: "bg-danger",
    purple: "bg-purple",
  };

  const iconColorMap = {
    blue: "text-white",
    green: "text-white",
    red: "text-white",
    purple: "text-white",
  };

  useEffect(() => {
    let interval;

    if (isTimerRunning) {
      interval = setInterval(() => {
        setTimeElapsed((prev) => prev + 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isTimerRunning]);

  useEffect(() => {
    fetchTimeData();
  }, []);

  const updateEndTime = async () => {
    const token = localStorage.getItem("token");
    try {
      if (timeData.status === "COMPLETED") return;
      await axios.post(
        `${apiUrl}/api/faculty/end-time`,
        {
          examId: id,
          subjectId: subjectId,
          barcodeId: barcodeId,
          endTime: secondsRef.current,
          allocationType: allocationType,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
    } catch (error) { }
  };

  useEffect(() => {
    if (userType === "admin") return;
    const interval = setInterval(() => {
      updateEndTime();
    }, 10000);

    return () => clearInterval(interval);
  }, [userType]);
  useEffect(() => {
    if (userType === "admin") return;
    storeIpandLocation();
  }, [userType]);

  const getLocationandIp = async () => {
    try {
      let ip = null;
      try {
        const ipResponse = await axios.get("https://api.ipify.org?format=json");
        ip = ipResponse.data.ip;
      } catch (ipError) {
        console.warn("Primary IP service failed, trying backup...");
        try {
          const backupIpResponse = await axios.get("https://ipapi.co/json/");
          ip = backupIpResponse.data.ip;
        } catch (backupIpError) {
          console.error("All IP services failed:", backupIpError);
        }
      }

      let lat = null,
        lon = null;
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            timeout: 5000,
            maximumAge: 60000,
            enableHighAccuracy: true,
          });
        });
        lat = position.coords.latitude;
        lon = position.coords.longitude;
      } catch (geoError) {
        console.warn("Geolocation error:", geoError);
      }

      return [ip, lat, lon];
    } catch (error) {
      console.error("Error in getLocationandIp:", error);
      return [null, null, null];
    }
  };

  async function storeIpandLocation() {
    try {
      const [ip, lat, lon] = await getLocationandIp();
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${apiUrl}/api/faculty/facultylocation`,
        {
          examId: id,
          subjectId: subjectId,
          barcodeId: barcodeId,
          startIpaddress: ip,
          startlatitude: lat,
          startlongitude: lon,
          allocationType: allocationType,
        },
        {
          headers: { Authorization: token },
          timeout: 10000, // 10 second timeout
        }
      );
    } catch (error) {
      console.error("Store location error:", error);
    }
  }

  const focusInput = (questionId) => {
    if (inputRefs.current[notAttended]) {
      inputRefs.current[notAttended].focus();
    }
  };

  const backtopageExit = async () => {
    try {
      await stopCamera(); // Ensure camera is stopped first

      if (userType === "admin") {
        navigate(-1); // Go back for admin
      } else {
        // Regular user navigation based on allocation type
        if (allocationType === "NORMAL") {
          navigate("/AllocateSheets", {
            state: { id, subjectId },
          });
        } else if (allocationType === "REASSESSMENT") {
          navigate("/ReassAllocate", {
            state: { id, subjectId },
          });
        } else {
          // Fallback if allocationType is not recognized
          toast.error("Unknown allocation type");
        }
      }
    } catch (error) {
      console.error("Error during exit:", error);
      toast.error("Error while exiting");
    }
  };

  const stopCamera = () => {
    return new Promise((resolve) => {
      setIsProcessing(true);

      if (userType === "admin") {
        setIsProcessing(false);
        resolve();
        return;
      }

      const video = videoRef.current;
      if (video && video.srcObject) {
        const stream = video.srcObject;
        stream.getTracks().forEach((track) => track.stop());
        video.srcObject = null;
      }

      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      setTimeout(() => {
        setIsProcessing(false);
        resolve();
      }, 300);
    });
  };

  const captureImage = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const base64 = canvas.toDataURL("image/jpeg").split(",")[1];

    try {
      const response = await fetch(`${apiUrl}/api/faculty/storephoto`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify({
          examId: id,
          subjectId,
          barcode,
          base64,
          allocationType,
        }),
      });

      const data = await response.json();
    } catch (error) {
      console.error("Error sending photo:", error);
    }
  };

  useEffect(() => {
    if (userType === "admin" || timeData?.webcam !== true) {
      return;
    }

    navigator.permissions.query({ name: "camera" }).then((permissionStatus) => {
      if (permissionStatus.state === "denied") {

        if (status === "COMPLETED") {
          toast.error("Camera access is required for this page");
          navigate(-1);
        }
        return;
      }

      if (!cameraEnabled) return;

      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          const video = videoRef.current;
          if (video) {
            video.srcObject = stream;
            video.onloadedmetadata = () => {
              video.play();
              intervalRef.current = setInterval(() => {
                captureImage();
              }, 5000);
            };
          }
        })
        .catch((err) => {
          console.error("Camera access failed:", err);

          if (status === "COMPLETED") {

            toast.error("Camera access is required");
            navigate(-1);
          }
        });
    });

    return () => {
      stopCamera();
    };
  }, [cameraEnabled, userType, timeData?.webcam]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== "USER" && role !== "ADMIN") {
      navigate("/");
    }
    // eslint-disable-next-line
  }, [cameraEnabled]);

  // get faculty images in admin side

  const fetchFacultyImages = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${apiUrl}/api/faculty/getfacultyimages/${id}/${subjectId}/${facultyId}/${allocationType}/${barcode}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );


      if (response.data.success === false) {
        // Handle case when API returns success: false
        setFacultyImages([]);
        setFacultyThumbnails([]);
        setShowFacultyThumbnails(true); // Still show the modal but with "no images" message
        toast.error(
          response.data.message || "No images available for this faculty"
        );
        return;
      }

      if (response.data && response.data.images) {
        setFacultyImages(response.data.images);
        const formattedImages = response.data.images.map((img) => ({
          image: img.image,
          time: img.time,
        }));
        setFacultyThumbnails(formattedImages);
        setShowFacultyThumbnails(true);
      } else {
        setFacultyImages([]);
        setFacultyThumbnails([]);
        setShowFacultyThumbnails(true);
        toast.info("No images available for this faculty");
      }
    } catch (error) {
      console.error("Error fetching faculty images:", error);
      setFacultyImages([]);
      setFacultyThumbnails([]);
      setShowFacultyThumbnails(true);
      toast.error(
        error.response?.data?.message || "Failed to load faculty images"
      );
    }
  };

  //----------- Api Call for Image path loding and secod api call was actual image loding ----------
  useEffect(() => {
    if (fetchTimeoutId.current) {
      clearTimeout(fetchTimeoutId.current);
    }
    fetchTimeoutId.current = setTimeout(() => {
      jsonDatalode();
    }, 300);
    return () => {
      if (fetchTimeoutId.current) {
        clearTimeout(fetchTimeoutId.current);
      }
    };
    // eslint-disable-next-line
  }, [apiUrl, id, subjectId, barcode, pathname]);

  //----------- Api Call for Image path loding and secod api call was actual image loding  funton ----------
  const jsonDatalode = (imageName, index) => {
    const token = localStorage.getItem("token");

    async function fetchFirstAPI() {
      try {
        // Conditionally add facultyId to the URL
        const firstApiUrl =
          `${apiUrl}/api/answersheet/image/detail/${id}/${subjectId}/${barcode}?allocationType=${allocationType}` +
          (facultyId ? `&facultyId=${facultyId}` : ""); // Add facultyId if it exists

        const response = await axios.get(firstApiUrl, {
          headers: {
            Authorization: `${token}`,
          },
        });

        setPagecount(response.data.totalPages);
        setTimeout(() => {
          addIconToStage();
        }, 5000);

        const pageValues = response.data.pages
          .map((page) =>
            Object.entries(page)
              .filter(([key, value]) => key.startsWith("page-"))
              .map(([key, value]) => value)
          )
          .flat();

        const page = response.data.pages[index ?? currentIndex];
        setSkeepPage(page.removePage);
        if (page) {
          handleClean(true);
          if (page?.imageJson && page?.imageJson?.length > 0) {
            page.imageJson.map((image, imageIndex) => {
              if (image?.x) {
                setTimeout(() => {
                  addIconToStage(
                    `/assets/img/${image.path}`,
                    image.x,
                    image.y,
                    image.width,
                    image.height,
                    image.zIndex
                  );
                }, 350);
              }
            });
          }
        }

        setPageValues(pageValues);
      } catch (error) {
        console.log("Error fetching the first API data"); // Log any errors
        error.response?.status === 401 && navigate("/");
      }
    }

    async function fetchSecondAPI() {
      try {
        setLoading(true); // Set loading to true before making the API call
        // Conditionally add facultyId to the URL
        const secondApiUrl =
          `${apiUrl}/api/answersheet/image/${id}/${subjectId}/${barcode}/${imageName ?? pathname
          }?allocationType=${allocationType}` +
          (facultyId ? `&facultyId=${facultyId}` : ""); // Add facultyId if it exists

        const response = await axios.get(secondApiUrl, {
          headers: {
            Authorization: token,
          },
        });

        setImage(response.data.base64Image); // Set the image state with the base64 image
      } catch (error) {
        error.response?.status === 401 && navigate("/");
        // Handle error if needed
      } finally {
        setTimeout(() => {
          setLoading(false); // Set loading to false after the API call
        }, 4000);
      }
    }

    // Start the loading indicator for the second API call
    setLoading(true);

    // Fetch the first API data immediately
    fetchFirstAPI();

    // Set a timeout to call the second API after 1 second
    const fetchSecondAPITimeout = setTimeout(() => {
      fetchSecondAPI();
    }, 0); // Adjust the delay as needed

    // Clean up function
    return () => {
      clearTimeout(fetchSecondAPITimeout); // Clear the timeout if the component unmounts or the effect runs again
    };
  };

  // ---------------------------------------------------- konva start here ----------------------------------------

  //----------- function that are work for  set image  position and stage --------------
  const initializeStage = () => {
    const stageContainer = stageRef.current;
    stageContainer.style.height = "99.2vh"; // Set your desired height
    stageContainer.style.width = "71vw";
    stageContainer.style.overflowY = "auto";

    // Konva stage setup
    const stage = new Konva.Stage({
      container: stageContainer,
      width: 839,
      height: 1000,
      draggable: false, // Initially not draggable
    });

    const layer = new Konva.Layer();
    stage.add(layer);
    layerRef.current = layer;

    const imageObj = new window.Image();

    imageObj.onload = () => {
      const img = new Konva.Image({
        x: 0,
        y: 10,
        width: 839,
        height: 1000,
        image: imageObj,
        draggable: true,
        listening: true, // Enable listening to events
        name: "img",
        listening: false,
        zIndex: -1,
      });
      layer.add(img);
      layer.draw();
      // Drag event listeners
      layer.on("dragstart", (e) => {
        setAction(true);
      });
      const tr = new Konva.Transformer({
        rotateEnabled: false,
      });
      layer.add(tr);
      transformerRef.current = tr;

      stage.on("click", (e) => {
        if (e.target === stage) {
          deselectElement();
        }
      });

      setStage(stage); // Store the stage instance in state
      setLoading(false); // Set loading to false after image has loaded
    };

    imageObj.onerror = () => {
      setLoading(false); // Set loading to false in case of error
    };

    imageObj.src = `${image}`; // Set the source of the image to the base64 string in the state

    // Handle zooming only when the Control key is pressed
    stage.on("wheel", (e) => {
      if (!e.evt.ctrlKey) {
        return; // Exit if the Control key is not pressed
      }

      e.evt.preventDefault(); // Prevent default scrolling behavior

      const scaleBy = 1.05; // Adjust this value for faster/slower zooming
      const oldScale = stage.scaleX(); // Assuming uniform scaling (x and y are the same)
      const pointer = stage.getPointerPosition(); // Get current mouse position

      // Calculate the new scale based on the scroll direction
      const newScale =
        e.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;

      // Calculate the position to keep the zoom centered on the mouse pointer
      const mousePointTo = {
        x: (pointer.x - stage.x()) / oldScale,
        y: (pointer.y - stage.y()) / oldScale,
      };

      // Apply the new scale
      stage.scale({ x: newScale, y: newScale });

      // Adjust the position to keep the zoom centered
      const newPos = {
        x: pointer.x - mousePointTo.x * newScale,
        y: pointer.y - mousePointTo.y * newScale,
      };

      stage.position(newPos);
      stage.batchDraw();

      // Enable dragging only if the stage is zoomed in or out (not at default scale)
      stage.draggable(newScale !== 1);
    });

    // Handle arrow key presses to drag the stage left and right
    const moveStageBy = 10; // The amount of pixels to move the stage by

    window.addEventListener("keydown", (e) => {
      // Only allow dragging with arrow keys if the stage is zoomed in or out
      if (stage.scaleX() === 1) return;

      switch (e.key) {
        case "ArrowLeft":
          stage.x(stage.x() + moveStageBy); // Move stage to the right (because of the coordinate system)
          stage.batchDraw();
          break;
        case "ArrowRight":
          stage.x(stage.x() - moveStageBy); // Move stage to the left
          stage.batchDraw();
          break;
        default:
          break;
      }
    });
  };

  //----------------- {konva}initializeStage when the image state changes --------------
  useEffect(() => {
    if (image) {
      initializeStage(image);
    }
    // Initialize with an empty array
  }, [image]); // Initialize with an empty array

  useEffect(() => {
    initializeStage();
    return () => {
      if (layerRef?.current) layerRef?.current?.destroy();
      if (stageRef?.current) stageRef?.current?.destroy();
    };
    // eslint-disable-next-line
  }, []);

  //----------- function that are work for add icons to stage {konva function}--------------
  const addIconToStage = (src, x, y, width, height, zIndex) => {
    const image = new window.Image();
    image.onload = () => {
      const icon = new Konva.Image({
        image: image,
        x: x,
        y: y ?? scrollPosition,
        width: width,
        height: height,
        draggable: true,
        zIndex: zIndex,
      });
      icon.on("click", (e) => {
        selectElement(e.target);
      });
      layerRef.current.add(icon);
      layerRef.current.batchDraw();
    };
    image.src = src;
  };
  // ----------------------------------- konva End --------------------------------------------
  // Function to scroll the div to the top
  const scrollToTop = () => {
    if (stageRef.current) {
      stageRef.current.scrollTop = 0;
    }
  };

  //------------------- image pagination(PreviousValue) -------------
  const showPreviousValue = () => {
    const isActionFalse = Action === "false" || Action === false;
    setCurrentIndex((prevIndex) => {
      const newIndex = Math.max(0, prevIndex - 1);
      if (StaTus !== "COMPLETED" && !isActionFalse) {
        handleButtonClick();
      }
      setTimeout(() => {
        scrollToTop(); // Scroll to the top
      }, 300);
      setAction(false);
      return newIndex;
    });
  };

  //------------------- image pagination(NextValue)----------------
  const showNextValue = () => {
    const isActionFalse = Action === "false" || Action === false;
    setCurrentIndex((prevIndex) => {
      const newIndex = Math.min(pageValues.length - 1, prevIndex + 1);
      if (StaTus !== "COMPLETED" && !isActionFalse) {
        handleButtonClick();
      }
      setTimeout(() => {
        scrollToTop(); // Scroll to the top
      }, 300);
      setAction(false);
      return newIndex;
    });
  };
  //----------------------- Function to zoom in -----------------
  const zoomIn = () => {
    if (!stage) return; // Ensure stage is initialized
    const scaleBy = 1.1; // Zoom factor
    const oldScale = stage.scaleX();
    const newScale = oldScale * scaleBy;
    stage.draggable(true);
    // Set a maximum zoom level to prevent over-zooming
    if (newScale > 3) return; // Example max scale limit
    stage.scale({ x: newScale, y: newScale });
    // Adjust position to keep the stage centered
    const stageWidth = stage.width();
    const stageHeight = stage.height();
    const newPos = {
      x: (stageWidth - stageWidth * newScale) / 2,
      y: (stageHeight - stageHeight * newScale) / 2,
    };
    stage.position(newPos);
    stage.batchDraw(); // Efficient redraw
  };
  //--------------------------- Function to zoom out ------------------
  const zoomOut = () => {
    if (!stage) return; // Ensure stage is initialized
    const scaleBy = 1.1; // Zoom factor
    const oldScale = stage.scaleX();
    const newScale = oldScale / scaleBy;
    stage.draggable(true);
    // Set a minimum zoom level to prevent under-zooming
    if (newScale < 0.5) return; // Example min scale limit

    stage.scale({ x: newScale, y: newScale });

    // Adjust position to keep the stage centered
    const stageWidth = stage.width();
    const stageHeight = stage.height();
    const newPos = {
      x: (stageWidth - stageWidth * newScale) / 2,
      y: (stageHeight - stageHeight * newScale) / 2,
    };

    stage.position(newPos);
    stage.batchDraw(); // Efficient redraw
  };
  //--------------------------- Function to reset zoom to original state ------------------
  const resetZoom = () => {
    if (!stage) return;
    // Reset scale and position to default values
    stage.scale({ x: 1, y: 1 });
    stage.position({ x: 0, y: 0 });
    // Reset the zoom level state if you have a slider or other UI element
    // Disable dragging when zoomed out to default level
    stage.draggable(false);
    // Redraw the stage
    stage.batchDraw();
  };
  //-------------- Add Checkmark icon in AnswerSheet ----------------------
  const handleAddCheckMark = () => {
    setAction(true);
    addIconToStage("/assets/img/correct.svg");
  };
  //--------------------Add Cross icon in AnswerSheet -----------------------
  const handleAddCrossTick = () => {
    setAction(true);
    addIconToStage("/assets/img/incorrect.svg");
  };
  //------------------ Add Duble slash icon in AnswerSheet -------------------
  const handleAddslash = () => {
    addIconToStage("/assets/img/blank-page.svg");
  };
  //------------------------- Clean all icon in AnswerSheet -------------------
  const handleClean = (isButtonClick) => {
    const img = layerRef?.current?.findOne(".img");
    layerRef?.current?.destroyChildren();
    if (img) {
      layerRef.current.add(img);
    }
    layerRef?.current?.batchDraw();
    const tr = new Konva.Transformer({
      rotateEnabled: false,
    });
    layerRef.current.add(tr);
    transformerRef.current = tr;
    console.log(isButtonClick, "isButtonClick");
    if (!isButtonClick) {
      setTimeout(() => {
        handleButtonClick();
      }, 100);
    }
  };
  //--------------- Delete Element  in AnswerSheet ----------------
  const handleDelete = () => {
    const selectedElement = selectedElementRef.current;
    if (selectedElement) {
      selectedElement.remove();
      transformerRef.current.detach();
      layerRef.current.draw();
    }
  };
  //----------------------select Element sign in AnswerSheet ----------------
  const selectElement = (element) => {
    setAction(true);
    selectedElementRef.current = element;
    transformerRef.current.nodes([element]);
    const layer = layerRef.current;
    if (layer) {
      transformerRef.current.getLayer().batchDraw();
    }
    // Retrieve and log the selected element's width and height
    const elementWidth = element.width();
    const elementHeight = element.height();
    if (element.className === "Text") {
      // If it's a Text element, set the input text to the element's current text
      // setInputText(element.text());
    } else {
      // For other elements, we can log or handle width/height in a different way
      // setInputText('');
    }
  };
  //---------------select Any icon second time click disable frame ----------------
  const deselectElement = () => {
    selectedElementRef.current = null;
    transformerRef.current.detach();
    layerRef.current.draw();
    transformerRef.current.nodes([]);
    layerRef.current.batchDraw();
  };
  //------------------- Qsn not attend to call this function -----------------
  const handleAddWarning = () => {
    if (!barcodeId || !notAttended || !notsectonId) {
      toast.warning("please sir select question ");
      return;
    }

    const token = localStorage.getItem("token");
    let data = {
      questionMarkData: {
        barcodeId: barcodeId,
        questionId: notAttended,
        isOrQus: isOrQus,
      },
      allocationType: allocationType,
      sectionId: notsectonId,
      isOtherSectionQuestion: isOtherSectionQuestion,
    };
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/not-atepmted/qus`,
      headers: {
        Authorization: token, // Replace 'YourAuthToken' with your actual token
      },
      data: data,
    };
    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success("Qsn not attend save successfully");
        setTimeout(() => {
          pagesecton();
        }, 300);
        setNotAttended();
        setScores((prevScores) => ({ ...prevScores, [notAttended]: "N/A" }));
        focusInput(notAttended);
        setNotsectonId("");
        setisOtherSectionQuestion("");
      })
      .catch((error) => {
        error.response?.status === 401 && navigate("/");
        console.log(error);
        toast.error(error.response.data.message);
        setNotAttended();
        setNotsectonId("");
        focusInput(notAttended);
        setisOtherSectionQuestion("");
      });
  };

  // Fetch data on component mount or when dependencies change
  useEffect(() => {
    pagesecton();
  }, [id, subjectId, apiUrl]);

  const pagesecton = async () => {
    const token = localStorage.getItem("token");
    try {
      // Conditionally build the URL by checking if facultyId is defined
      const url =
        `${apiUrl}/api/section/sectionList/${id}/${subjectId}?barcodeId=${barcodeId}&allocationType=${allocationType}` +
        (facultyId ? `&facultyId=${facultyId}` : ""); // Add facultyId if it exists

      const response = await axios.get(url, {
        headers: {
          Authorization: token,
        },
      });

      // Flatten the sections and questions
      const sectionsWithQuestions = response.data.sections.map((section) => ({
        sectionName: section.name,
        noOfAnyQus: section.noOfAnyQus,
        sectionType: section.sectionType,
        sectionId: section.id,
        questions: section.questions.map((question, questionIndex) => ({
          ...question,
          uniqueKey: `${section.id}-${question.id}-${questionIndex}`, // Unique key
        })),
      }));

      setAllQuestions(sectionsWithQuestions);
      setStatus(response.data);
    } catch (err) {
      err.response?.status === 401 && navigate("/");
      console.error("API call failed:", err);
      // Optionally handle the error state here
    }
  };

  // Handle score change
  const handleScoreChange = (e, id) => {
    const score = parseFloat(e.target.value);
    const newScore = isNaN(score) ? "" : score;
    setScores((prevScores) => ({
      ...prevScores,
      [id]: newScore, // Store the score as a number
    }));
  };
  // this function for chake isOtherQuestions and or qsn is true and false
  const handleButtonClick = (question) => {
    // Set states based on the question details
    setLoaded(true);
    setClickedRowId(question?.id);
    setisOtherQuestions(question?.isOtherQuestions);

    // Retrieve and filter icons from the layer
    const icons = layerRef.current.getChildren((node) =>
      ["Image", "Path"].includes(node.getClassName())
    );
    const filteredIcons = icons.filter((icon) => icon.getZIndex() !== 0);

    // Map positions of icons into an array
    const positionsArray = filteredIcons.map((icon) => {
      const iconClientRect = icon.getClientRect();
      const { src } = icon.attrs.image;

      return {
        x: icon.x() || 120,
        y: icon.y() || 120,
        width: iconClientRect.width,
        height: iconClientRect.height,
        path: src.split("/").pop(),
        zIndex: icon.getZIndex(),
      };
    });

    const token = localStorage.getItem("token");
    const questionIdStr = question?.id ? String(question?.id) : "";
    const formattedQuestionId = questionIdStr.replace(/^0+/, ""); // Remove leading zeros
    const questionMarks = scores?.[question?.id] ?? ""; // Fallback to 0 if undefined

    const requestData = {
      allocationType: allocationType,
      questionMarkData: {
        marks: parseInt(questionMarks, 10),
        barcodeId: barcodeId,
        questionId: parseInt(formattedQuestionId, 10), // Ensure numeric ID
        isOrQus: question?.isOrQus || false, // Fallback to false
        isOtherSectionQuestion: question?.isOtherSectionQuestion || false, // Fallback to false
        isAnyQus: question?.isAnyQus, // Fallback to false
        noOfAnyQus: question?.noOfAnyQus, // Fallback to false
        isNotAttemptedQus: question?.isNotAttemptedQus,
      },
      answerSheetPageData: {
        imageName: pathname,
        examId: id,
        subjectId: subjectId,
        imageJson: positionsArray,
        barcodeId: barcodeId,
        pageNo: currentIndex + 1,
      },
    };

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/marks-page/save`,
      headers: {
        Authorization: token,
      },
      data: requestData,
    };

    // API request to save marks and page data
    axios
      .request(config)
      .then((response) => {
        console.log("API Response:", response.data);

        // Refresh page section and reset loader
        pagesecton();
        setLoaded(false);
        setAction(false);
      })
      .catch((error) => {
        focusInput(notAttended);
        console.error("API Error:", error);
        error.response?.status === 401 && navigate("/");
        setScores({});
        // Handle API error messages gracefully
        const errorMessage =
          error.response?.data?.message || "An unexpected error occurred";
        toast.error(errorMessage);
        setAction(false);
        // Reset loader and refresh page section
        setLoaded(false);
        pagesecton();
      });
  };

  // ------------------ close model after submit----------------------
  const closemodel = () => {
    const closeButton = document.querySelector("#modal4 .btn-close");
    if (closeButton) {
      closeButton.click();
    }
    if (currentPath === "/ViewAnswerSheet") {
      const timeOutDuration = 3000;
      const timeoutId = setTimeout(() => {
        if (window.location.pathname === "/ViewAnswerSheet") {
          navigate(-1);
        }
      }, timeOutDuration);
      return () => clearTimeout(timeoutId);
    }
  };

  const closeModalReson = () => {
    const closeButton = document.querySelector("#modalReson .btn-close");
    if (closeButton) {
      closeButton.click();
    }
    if (currentPath === "/ViewAnswerSheet") {
      const timeOutDuration = 3000;
      const timeoutId = setTimeout(() => {
        if (window.location.pathname === "/ViewAnswerSheet") {
          navigate(-1);
        }
      }, timeOutDuration);
      return () => clearTimeout(timeoutId);
    }
  };
  //------------------ show question paper --------------------------
  const openQuestionPaper = () => {
    const token = localStorage.getItem("token");
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/getQuestionPaperAndAnswerKey/${id}/${subjectId}`,
      headers: {
        Authorization: `${token}`,
      },
    };

    setLoading(true);
    axios
      .request(config)
      .then((response) => {
        const byteCharacters = atob(response.data.questionPaperContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        setPdfBlob(URL.createObjectURL(blob));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching PDF:", error);
        error.response?.status === 401 && navigate("/");
        setLoading(false);
      });
  };
  //-------------------------- show answer key pdf ---------------------
  const openAnswerSheet = () => {
    const token = localStorage.getItem("token");
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/getQuestionPaperAndAnswerKey/${id}/${subjectId}`,
      headers: {
        Authorization: `${token}`,
      },
    };

    setLoading(true);
    axios
      .request(config)
      .then((response) => {
        const byteCharacters = atob(response.data.answerKeyContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        setAnswerKeyBlob(URL.createObjectURL(blob));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching PDF:", error);
        error.response?.status === 401 && navigate("/");
        setLoading(false);
      });
  };
  //----------------------  final submit of answer sheet function ---------------------
  const finalSubmit = async () => {
    const token = localStorage.getItem("token");
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/submit/${barcodeId}?allocationType=${allocationType}`,
      headers: {
        Authorization: `${token}`,
      },
    };

    const [ip, lat, lon] = await getLocationandIp();

    try {
      await axios.put(
        `${apiUrl}/api/faculty/update/userlocation`,
        {
          examId: id,
          subjectId: subjectId,
          barcodeId: barcodeId,
          endIpaddress: ip,
          endlatitude: lat,
          endlongitude: lon,
          endtime: secondsRef.current,
          allocationType: allocationType,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
    } catch (error) {
      console.log("Error fetching IP:", error);
    }

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        toast.success("Answer sheet submitted successfully");
        closemodel();
      })
      .catch((error) => {
        console.log(error);
        error.response?.status === 401 && navigate("/");
        toast.error(
          error.response.data.message ||
          `${error?.response?.data?.error}${error?.response?.data?.notAttemptedPages
            ? ` Not attempted pages: ${error.response.data.notAttemptedPages.join(
              ", "
            )}`
            : ""
          }`
        );
      });
  };
  //--------------------- grand total table  api call -----------------
  const GrandTotalTable = () => {
    const token = localStorage.getItem("token");
    let data = {
      subjectId: subjectId,
      examId: id,
      barcodeId: barcodeId,
      allocationType: allocationType,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/section/barcode/marks`,
      headers: {
        Authorization: token, // Replace 'YourAuthToken' with your actual token
      },
      data: data,
    };
    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setGrandTotal(response.data.sections);
        if (StaTus !== "COMPLETED") {
          handleButtonClick();
        }
      })
      .catch((error) => {
        error.response?.status === 401 && navigate("/");
        console.log(error);
        toast.error(error.response.data.message);
      });
  };
  //  grandTotal columns
  const grandTotalcolumns = [
    {
      name: "No",
      cell: (row, index) => index + 1,
      width: "50px",
      center: "true",
    },
    {
      name: "Section",
      selector: (row) => row.sectionName,
    },
    {
      name: "Total Questions",
      selector: (row) => row.questionCount,
    },
    {
      name: "Chaked Questions",
      selector: (row) => row.checkQus,
    },
    {
      name: "Total Marks",
      selector: (row) => row.totalMarks,
    },
    {
      name: "Score",
      selector: (row) => row.score,
    },
  ];
  //------- this function is for delete button click in keyboard shortcut---------
  const handleKeyDown = (event) => {
    if (event.key === "Delete") {
      handleDelete();
    }
  };

  useEffect(() => {
    // Add keydown event listener
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Function to fetch thumbnails
  const fetchThumbnail = async () => {
    openNav();
    setIsVisible(true);
    const token = localStorage.getItem("token");
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/imageIndex/${id}/${subjectId}/${barcode}`,
      headers: {
        Authorization: token,
      },
    };
    try {
      const response = await axios.request(config);
      // Check if images exist in the response
      if (response.data.images && response.data.images.length > 0) {
        const urls = response.data.images.map(
          (image) => `${image.base64Image}`
        );
        setThumbnailUrls(urls); // Set all base64 image URLs
        setImages(response.data.images); // Store the images array in state
      }
    } catch (error) {
      error.response?.status === 401 && navigate("/");
      console.error(error);
    } finally {
      console.log("Thumbnail fetch completed");
    }
  };

  const handleThumbnailClick = (imageName, index,) => {
    const isActionFalse = Action === "false" || Action === false;
    if (StaTus !== "COMPLETED" && !isActionFalse) {
      handleButtonClick();
    }
    setTimeout(() => {
      scrollToTop(); // Scroll to the top
    }, 300);
    setCurrentIndex(index);
    jsonDatalode(imageName, index);
  };

  const openNav = () => {
    setIsOpen(true);
  };

  const closeNav = () => {
    setIsOpen(false);
    setIsVisible(false);
    setFacultyLocationTime(false);
  };

  // Fetch data on button click
  const fetchReasons = () => {
    const token = localStorage.getItem("token");
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/rejectreason/reasonlist`,
      headers: {
        Authorization: token,
      },
    };

    axios
      .request(config)
      .then((response) => {
        // Set the response data to the reasons state
        setReasons(response.data);
      })
      .catch((error) => {
        error.response?.status === 401 && navigate("/");
        console.error("Error fetching reasons:", error);
      });
  };

  const SubmitReason = () => {
    const token = localStorage.getItem("token");
    if (!selectedReason || !description) {
      toast.error("Please select a reason and enter a description");
      return;
    }

    // Prepare data for the API request
    const data = JSON.stringify({
      reasonId: parseInt(selectedReason),
      barcodeId: barcodeId, // Pass the actual barcodeId
      text: description,
      examId: id,
      subjectId: subjectId,
    });

    // Axios configuration
    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/rejectedansersheet/add`,
      headers: {
        Authorization: token, // Pass the facultyToken
        "Content-Type": "application/json",
      },
      data: data,
    };

    // Perform the API request
    axios
      .request(config)
      .then((response) => {
        toast.success("Sheet rejected successfully");
        setReasons([]);
        setSelectedReason("");
        setDescription("");
        closeModalReson();
      })
      .catch((error) => {
        error.response?.status === 401 && navigate("/");
        toast.error(error.response.data.message);
      });
  };
  // Question paper and answer key download function
  function QuestionPaper() {
    saveAs(pdfBlob, "QuestionPaper.pdf");
  }
  function AnswerKey() {
    saveAs(answerKeyBlob, "AnswerKey.pdf");
  }

  // blank page add slash function add
  function BlankPage() {
    handleAddslash();
    setTimeout(() => {
      handleButtonClick();
    }, 100);
  }

  // get stage scroll position and set it in state
  useEffect(() => {
    const container = stageRef.current;
    const handleScroll = () => {
      const scrollPositionY = container.scrollTop;
      setScrollPosition(scrollPositionY);
    };
    container.addEventListener("scroll", handleScroll);
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* main div  for holding konva and all the elements */}
      <div className="d-flex flex-row ">
        {/*------------------------------- left-tools ----------------------------------------*/}
        <div className="left-tools bg-white">
          <div className="d-grid gap-2 mt-2 m-2 mb-4">
            <button
              className="btn btn-secondary round btn-sm"
              data-tooltip-id="my-tooltip"
              data-tooltip-content=" Sheet Barcode"
              type="button"
            >
              {barcode}
            </button>
          </div>
          <div className="d-flex justify-content-between">
            <div className="p-1 bd-highlight">
              <label className="bold ">
                Score:-{status.totalScore}/{status.totalMarks}
              </label>
            </div>
            <div className="p-1 bd-highlight">
              <h6>
                <span
                  className={`badge mt-1  ${status.status === "pass" ? "bg-success" : "bg-danger"
                    }`}
                >
                  <i className="bi bi-award"></i> {status.status}
                </span>
              </h6>
            </div>
          </div>

          {/*--------------------------------- section table ------------------------------*/}
          <div className="table-container-secton p-1">
            {allQuestions.map((section) => (
              <div key={`section-${section.sectionId}`}>
                {/* Section Name Row */}
                <h6 className="mb-0">
                  {section.sectionName} {section.sectionType}
                  <strong>
                    {section.noOfAnyQus > 0 && ` ${section.noOfAnyQus}`}
                  </strong>
                </h6>
                <table className="table table-bordered table-secton">
                  <thead>
                    <tr>
                      <th>QSN</th>
                      <th>Score</th>
                      <th>Marks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {section.questions.map((question, questionIndex) => {
                      const showOr =
                        section.sectionType === "Or Section" &&
                        question.isOtherSectionQuestion &&
                        section.questions.findIndex(
                          (q) => q.isOtherSectionQuestion
                        ) === questionIndex;

                      return (
                        <React.Fragment key={question.uniqueKey}>
                          {showOr && (
                            <tr>
                              <td colSpan={3} className="text-center">
                                <div className="orqsn">
                                  <strong>-- OR --</strong>
                                </div>
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td>
                              <div style={{ marginTop: "7px" }}>
                                <strong>{question.no}</strong>
                              </div>
                            </td>
                            <td>
                              <input
                                ref={(el) =>
                                  (inputRefs.current[question.id] = el)
                                } // Assign ref for each question ID
                                type="text"
                                value={
                                  scores[question.id] !== undefined
                                    ? scores[question.id]
                                    : question.score || ""
                                }
                                onChange={(e) => {
                                  handleScoreChange(e, question.id);
                                  setAction(true); // Set action to true when the input changes
                                }}
                                className="form-control text-center"
                                onFocus={() => {
                                  setNotAttended(question.id);
                                  setNotsectonId(section.sectionId);
                                  setisOtherSectionQuestion(
                                    question.isOtherSectionQuestion
                                      ? true
                                      : false
                                  );
                                  setIsOrQus(question.isOrQus ? true : false);
                                }}
                                onBlur={() => {
                                  if (Action) {
                                    handleButtonClick(question); // Call handleButtonClick only if Action is true
                                  }
                                }}
                                disabled={userType === "admin"}
                                // Set the maximum length to 2
                                maxLength={2}
                              />
                            </td>
                            <td>
                              <input
                                className="form-control text-center"
                                type="text"
                                value={question.marks}
                                disabled
                              />
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
        {/*-------------------------------- main-colum ---------------------------------------*/}
        <div className="main-colum">
          {userType === "admin" && skeepPage == true ? (
            <span className=" position-absolute top-0 end-0 news-date">

              <strong >SKIP</strong>

            </span>
          ) : null}
          {loading && (
            // Show loader while loading
            <div
              className="spinner-border text-primary positi-loder position-absolute top-50 start-50"
              role="status"
            />
          )}
          <div ref={stageRef} id="container" className="Kanva-man "></div>
        </div>

        {/*--------------------------------- right-tools ---------------------------------------*/}
        <div className="right-tools ">
          <section>
            <div
              id="mySidenav"
              className={`sidenav ${activePanel ? "open" : ""}`}
              style={{
                width:
                  activePanel === "faculty"
                    ? "43.5%"
                    : activePanel === "thumbnail"
                      ? "12.5%"
                      : "0",
                transition: "width 0.3s ease",
              }}
            >


              <div className="text-end p-2 sticky-top">
                <button
                  className="btn btn-sm text-dark rounded-pill fs-5 p-0 px-1 bg-light"
                  style={{ color: "#f1f1f1" }}
                  onClick={() => {
                    setActivePanel("")
                    closeNav()
                  }}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
              <div className="table-div">
                <div className="thumbnail-container">
                  {isVisible && (
                    <div className="thumbnails border">
                      {thumbnailUrls.length > 0 ? (
                        thumbnailUrls.map((url, index) => (
                          <div className="thumbnail-wrapper" key={index}>
                            <img
                              src={url}
                              alt={`Thumbnail ${index}`}
                              className="thumbnail-image border border-black cursor-pointer p-1"
                              onClick={() =>
                                handleThumbnailClick(
                                  images[index].imageName,
                                  index
                                )
                              }
                            />
                            <span className="page-number">{index + 1}</span>
                          </div>
                        ))
                      ) : (
                        <p>Loading thumbnails...</p>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="table-div table-div-2">
                <div className="thumbnail-container p-2">
                  {facultyLocationTime && (
                    <div className="thumbnails border p-3 rounded shadow-sm bg-white">
                      <h3 className="h5 fw-semibold text-dark mb-3">Faculty  Information</h3>
                      <table className="table table-bordered table-striped align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th scope="col" style={{ width: "80px" }}>Icon</th>
                            <th scope="col">Label</th>
                            <th scope="col">Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {locationFields.map((field, index) => {
                            const Icon = field.icon;
                            const bgClass = bgMap[field.color] || "bg-secondary";
                            const iconColor = iconColorMap[field.color] || "text-white";

                            return (
                              <tr key={index}>
                                <td className="text-center">
                                  <div
                                    className={`d-flex align-items-center justify-content-center rounded ${bgClass} ${iconColor}`}
                                    style={{ width: "22px", height: "22px", margin: "auto" }}
                                  >
                                    <Icon size={15} />
                                  </div>
                                </td>
                                <td className="fw-medium text-muted">{field.label}</td>
                                <td className={`fw-semibold ${field.available ? "text-dark" : "text-muted"}`}>
                                  {field.value}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>

            </div>
          </section>
          <div className="card text-center border mb-2 mt-2">
            <h6 className="card-title mb-1">
              <i className="bi bi-clock"></i> Time
            </h6>
            <div className="h5 mb-2 text-primary">
              {formatTime(timeData.totalTime)} / {formatTime(seconds)}
            </div>
          </div>
          <div className="card text-center border mb-0 mt-2 mb-4">
            PG NO: {currentIndex + 1}/{pagecount}
          </div>
          {/*----------------------- button area for modal  submiot -----------------------*/}
          <div className="d-flex justify-content-between mb-3">
            <div className="px-2  bd-highlight">
              <button
                type="button"
                className="btn btn-primary btn-sm mx-1"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Zoom Out"
                onClick={zoomOut}
              >
                <i className="bi bi-zoom-out"></i>
              </button>
            </div>
            <div className="px-2 bd-highlight">
              <button
                type="button"
                className="btn btn-primary btn-sm mx-1"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Zoom In"
                onClick={zoomIn}
              >
                <i className="bi bi-zoom-in"></i>
              </button>
            </div>
            <div className="px-2 bd-highlight">
              <button
                type="button"
                className="btn btn-primary btn-sm mx-1"
                onClick={resetZoom}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Reset Zoom"
              >
                <i className="bi bi-arrow-clockwise"></i>
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="px-2 bd-highlight" hidden={userType === "admin"}>
              {/* Button to add checkmark */}
              <button
                type="button"
                className="btn btn-success btn-sm  mx-1"
                onClick={handleAddCheckMark}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Correct"
              >
                <i className="bi bi-check-circle"></i>
              </button>
            </div>
            <div className="px-2 bd-highlight" hidden={userType === "admin"}>
              {/* Button to add cross */}
              <button
                type="button"
                className="btn btn-danger btn-sm mx-1"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="In Correct"
                onClick={handleAddCrossTick}
              >
                <i className="bi bi-x-circle"></i>
              </button>
            </div>
            <div className=" px-2 bd-highlight" hidden={userType === "admin"}>
              {/* Button to add slash */}
              <button
                type="button"
                className="btn btn-primary  btn-sm mx-1"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Blank Page"
                onClick={BlankPage}
              >
                <TbSlashes />
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="px-2 bd-highlight" hidden={userType === "admin"}>
              {/* Button to add not attend  */}
              <button
                type="button"
                className="btn btn-warning  btn-sm  mx-1"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Not Attempted"
                onClick={handleAddWarning}
              >
                {" "}
                <i className="bi bi-exclamation-triangle"></i>
              </button>
            </div>
            <div className=" px-2 bd-highlight" hidden={userType === "admin"}>
              {/* button to clean */}
              <button
                type="button"
                className="btn btn-secondary btn-sm  mx-1"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Page Clean"
                onClick={handleClean}
              >
                <MdCleaningServices />
              </button>
            </div>
            <div className=" px-2 bd-highlight" hidden={userType === "admin"}>
              {/* selected delete */}
              <button
                type="button"
                className="btn btn-danger btn-sm  mx-1"
                onClick={handleDelete}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Select Delete"
              >
                <i className="bi bi-trash3-fill"></i>
              </button>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div className="px-2 bd-highlight">
              <button
                type="button"
                className="btn btn-primary btn-sm  mt-1 me-4 "
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Previous Page"
                onClick={showPreviousValue}
              >
                <i className="bi bi-chevron-left"></i>
              </button>
            </div>
            <div className="px-1 bd-highlight"></div>
            <div className="px-2 bd-highlight">
              <button
                type="button"
                className="btn btn-primary btn-sm mt-1 ms-4 "
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Next Page"
                onClick={showNextValue}
              >
                <i className="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
          <div className="d-flex flex-column mb-3">
            <div className="p-2" hidden={userType === "admin"}>
              <button
                type="button"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Save Qsan Marks"
                className="btn btn-primary btn-sm w-100  "
                onClick={handleButtonClick}
                disabled={loaded}
              >
                {loaded ? (
                  <span
                    className="spinner-border spinner-border-sm  "
                    role="status"
                    aria-hidden="true"
                  >
                    {" "}
                  </span>
                ) : (
                  <>Save Page</>
                )}
              </button>
            </div>

            <div className="p-2">
              <button
                onClick={() => {
                  setActivePanel("thumbnail");
                  fetchThumbnail()
                }}
                className="btn btn-secondary btn-sm w-100 "
                data-tooltip-id="my-tooltip"
                data-tooltip-content="View Thumnal "
              >
                Thumbnail
              </button>
            </div>
            <div className="p-2" hidden={userType !== "admin"}>
              <button
                onClick={() => {
                  setActivePanel("faculty");
                  handleButtonIp()
                }}
                className="btn btn-primary btn-sm w-100 "
                data-tooltip-id="my-tooltip"
                data-tooltip-content="View Faculty Location Info"
              >
                Faculty Location
              </button>
            </div>
            <div className="p-2">
              <button
                onClick={() => openAnswerSheet()}
                className="btn btn-success btn-sm w-100 "
                data-bs-toggle="modal"
                data-bs-target="#modal2"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="View Answer Key"
              >
                {" "}
                Solution{" "}
              </button>
            </div>
            <div className="p-2">
              <button
                onClick={() => openQuestionPaper()}
                className="btn btn-primary btn-sm  w-100"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="View Question Paper"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                {" "}
                Question Paper
              </button>
            </div>
            <div
              className="p-2"
              hidden={userType === "admin" || allocationType === "REASSESSMENT"}
            >
              <button
                type="button"
                className="btn btn-danger btn-sm  w-100"
                data-bs-toggle="modal"
                data-bs-target="#modalReson"
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Reject Script some reason and issue add"
                onClick={fetchReasons}
              >
                Reject Script
              </button>
            </div>
            <div className="p-2" hidden={userType !== "admin"}>
              <button
                type="button"
                className="btn btn-info btn-sm w-100"
                data-bs-toggle="modal"
                data-bs-target="#facultyImagesModal"
                onClick={fetchFacultyImages}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="View faculty captured images"
              >
                <i className="bi bi-camera-fill me-1"></i> Faculty Images
              </button>
            </div>
            <div className="p-2" hidden={userType === "admin"}>
              <button
                type="button"
                className="btn btn-success btn-sm  w-100"
                data-bs-toggle="modal"
                data-bs-target="#modal4"
                onClick={GrandTotalTable}
                data-tooltip-id="my-tooltip"
                data-tooltip-content="Grand Total & final submit"
              >
                {" "}
                Submit
              </button>
            </div>
            <div className="p-2">
              <button
                type="button"
                className="btn btn-dark btn-sm w-100"
                onClick={backtopageExit}
              >
                Exit
              </button>

              {cameraEnabled && userType !== "admin" && (
                <>
                  <video ref={videoRef} style={{ display: "none" }} />
                  <canvas ref={canvasRef} style={{ display: "none" }} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div style={{ position: "relative" }}>
        {/* Full-screen processing overlay */}
        {isProcessing && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.7)",
              color: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "2rem",
              zIndex: 1000,
            }}
          >
            Processing...
          </div>
        )}
      </div>
      {/*-------------------------------- page modal area----------------------------------------- */}

      {/*---------------- this is daylog box for view question paper---------------------------------*/}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Question Paper
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {loading && <div>Loading...</div>}
              {pdfBlob && (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <div style={{ height: "500px" }}>
                    <Viewer fileUrl={pdfBlob} />
                  </div>
                </Worker>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={QuestionPaper}
              >
                Download
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*------------------------ this is daylog box for view answer key ----------------------------*/}
      <div
        className="modal fade"
        id="modal2"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        maria-labelledby="modal2Label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal2Label">
                Answer Key
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {answerKeyBlob && (
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <div style={{ height: "500px" }} className="pdf">
                    <Viewer fileUrl={answerKeyBlob} />
                  </div>
                </Worker>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary mr-1"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={AnswerKey}
              >
                Download
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*---------------------------------- this is daylog box for  grand total table & final submit ---------------------*/}
      <div
        className="modal fade"
        id="modal4"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modal3Label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal3Label">
                Grand Total
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body text-center p-1">
              <DataTable
                columns={grandTotalcolumns}
                data={grandTotal}
                className="custom-table"
              />
              <div className="d-flex justify-content-end ">
                <div className=" mt-2 mx-2 bd-highlight">
                  <label className="bold ">
                    <strong>
                      Score:-{status.totalScore}/{status.totalMarks}
                    </strong>
                  </label>
                </div>
                <div className=" mt-2 bd-highlight">
                  <span
                    className={`badge   ${status.status === "pass" ? "bg-success" : "bg-danger"
                      }`}
                  >
                    <i className="bi bi-award"></i> {status.status}
                  </span>
                </div>
              </div>
            </div>

            <div className="modal-footer d flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary px-4"
                data-bs-dismiss="modal"
              >
                {" "}
                <i className="bi bi-x-circle"></i> Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={finalSubmit}
              >
                <i className="bi bi-check2-square"></i> Final Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*------------------------ this is daylog box for Reject Sheet ----------------------------*/}
      <div
        className="modal fade"
        id="modalReson"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modal2Label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modal2Label">
                Rejected Sheet
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="col-sm-12">
                <select
                  className="form-select"
                  aria-label="Select Reason"
                  value={selectedReason}
                  onChange={(e) => setSelectedReason(e.target.value)}
                >
                  <option value="">Select Reason</option>
                  {reasons.map((reason) => (
                    <option key={reason.id} value={reason.id}>
                      {reason.text}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-12">
                <div className="form-floating mt-2">
                  <input
                    className="form-control"
                    type="text"
                    name="name"
                    placeholder="Reason Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />
                  <label className="form-label" htmlFor="txtGrNo">
                    Reason Description <span className="text-danger">*</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={SubmitReason}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Faculty Images Modal - Using Bootstrap classes */}
      <div
        className="modal fade"
        id="facultyImagesModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="facultyImagesModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="facultyImagesModalLabel">
                Faculty Captured Images ({facultyImages.length})
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-0">
              {/* Full view image container - hidden by default */}
              <div
                id="fullViewContainer"
                className="d-none position-relative bg-dark h-75"
              >
                <button
                  className="btn btn-sm btn-light position-absolute top-0 end-0 m-2 opacity-75 hover-opacity-100"
                  onClick={() => {
                    document
                      .getElementById("fullViewContainer")
                      .classList.add("d-none");
                    document
                      .getElementById("thumbnailGrid")
                      .classList.remove("d-none");
                  }}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
                <div className="d-flex justify-content-center align-items-center h-100 w-100">
                  <img
                    id="fullViewImage"
                    src=""
                    alt="Full view"
                    className="img-fluid h-auto mw-100 mh-100"
                  />
                </div>
                <div className="position-absolute bottom-0 start-0 end-0 text-center text-white p-2 bg-dark bg-opacity-75">
                  <span id="fullViewCaption" className="small"></span>
                </div>

                {/* Navigation arrows */}
                <button
                  className="btn btn-light position-absolute top-50 start-0 translate-middle-y opacity-75 hover-opacity-100 ms-2"
                  onClick={() => navigateImages(-1)}
                >
                  <i className="bi bi-chevron-left"></i>
                </button>
                <button
                  className="btn btn-light position-absolute top-50 end-0 translate-middle-y opacity-75 hover-opacity-100 me-2"
                  onClick={() => navigateImages(1)}
                >
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>

              {/* Thumbnail grid - visible by default */}
              <div id="thumbnailGrid" className="thumbnail-container">
                {showFacultyThumbnails ? (
                  <div className="thumbnails border">
                    {facultyImages.length > 0 ? (
                      facultyImages.map((img, index) => (
                        <div
                          className="thumbnail-wrapper position-relative"
                          key={index}
                        >
                          <img
                            src={img.image}
                            alt={`Faculty capture ${index + 1}`}
                            className="faculty-image border border-black cursor-pointer p-1 ratio ratio-4x3"
                            onClick={() => showFullImage(index)}
                          />
                          <span className="position-absolute top-0 start-0 m-1 bg-dark bg-opacity-75 text-white rounded-circle px-2 py-1 small">
                            {index + 1}
                          </span>
                          <span className="position-absolute bottom-0 start-0 end-0 text-center text-white p-2 bg-dark bg-opacity-75 small">
                            <div style={{ fontSize: "0.75rem", opacity: 0.8 }}>
                              {img.time
                                ? new Date(img.time).toLocaleString()
                                : "No time"}
                            </div>
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className="w-100 d-flex flex-column align-items-center justify-content-center py-5">
                        <div className="text-center mb-3">
                          <i
                            className="bi bi-image text-muted"
                            style={{ fontSize: "3rem" }}
                          ></i>
                        </div>
                        <div className="alert alert-info w-75 text-center">
                          <h5 className="alert-heading">No Images Available</h5>
                          <p className="mb-0">
                            No captured images found for this faculty member.
                          </p>
                        </div>
                        <div className="text-muted small mt-2">
                          Images will appear here when captured by the faculty
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="mt-3">Loading faculty images...</div>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                  document
                    .getElementById("thumbnailGrid")
                    .classList.remove("d-none");
                  document
                    .getElementById("fullViewContainer")
                    .classList.add("d-none");
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <Tooltip id="my-tooltip" place="bottom" />
      <ToastContainer position="top-center" style={{ width: "auto" }} />
    </>
  );
}